
import React, { useEffect, useState } from "react";
import { FaLeaf, FaHome, FaLayerGroup, FaHistory, FaCircle } from "react-icons/fa";
import "./Dashboard.css";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/img/Subtraction 2.svg";
import stampingLogo from '../../assets/img/stamp-solid-full (1).svg';
import logoutLogo from '../../assets/img/right-from-bracket-solid-full (1).svg'
import homeIcon from '../../assets/img/homeIcon.svg'
import userIcon from '../../assets/img/circle-user-solid-full.svg';
import profredingIocn from '../../assets/img/list-check-solid-full.svg'
import FrameIcon from '../../assets/img/Frame.svg'
import historyIcon from '../../assets/img/historyIcon.svg'
import axios from 'axios';
const Sidebar = ({ setActiveView, setActiveAdminView, activeAdminView, setActiveClientView }) => {
  const API_BASE_URL = 'https://api.waraq.co/waraq/api/v1';
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null)

  const loginType = localStorage.getItem("role");

  const logout = () => {
    localStorage.clear("jwtToken");
    navigate("/");
  };

  const getAuthHeaders = () => {
    const token = localStorage.getItem("jwtToken");
    return { Authorization: `${token}` };
  };

  const getUserInfo = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/user/profile`, {
        headers: getAuthHeaders()
      });
      const data = response?.data?.data;
      setUserData(data);

      // imageUrl
      console.log('user data:', data);  // ✅ Logs the actual data
    } catch (err) {
      console.error('Error fetching user profile:', err);
    }
  };

  useEffect(() => {

    getUserInfo();
  }, []);

  return (
    <>
      {loginType === "ADMIN" ? (
        <div className="sidebar">
          <div className="sidebar-logo">
            <img src={logo} alt="no logo" />
          </div>

          <div className="sidebar-nav">
            <p
              onClick={() => setActiveAdminView("home")}
              className={`nav-item ${activeAdminView === "home" ? "active" : ""}`}
            >
              <img style={{ width: '20px' }} src={homeIcon} alt='image not found ' />

            </p>
            <p
              onClick={() => setActiveAdminView("Request")}
              className={`nav-item ${activeAdminView === "Request" ? "active" : ""}`}
            >

              <img style={{ width: '30px' }} src={FrameIcon} alt='image not found' />

            </p>
            <p
              onClick={() => setActiveAdminView("Stamp")}
              className={`nav-item ${activeAdminView === "Stamp" ? "active" : ""}`}
            >
              <img style={{ width: '20px' }} src={stampingLogo} alt='image not found ' />

            </p>
            <p
              onClick={() => setActiveAdminView("historyDashboard")}
              className={`nav-item ${activeAdminView === "historyDashboard" ? "active" : ""}`}
            >
              <img style={{ width: '20px' }} src={historyIcon} alt='image not found' />

            </p>
          </div>

          <div className="sidebar-bottom">
            <div style={{ cursor: "pointer", marginBottom: '10px', color: '#FFF' }}>


              <img
                style={{ width: '20px', height: '20px', borderRadius: "50%" }}
                onClick={() => setActiveAdminView("userProfile")}
                src={userData?.imageUrl || userIcon}
                alt='image not found'
              />

            </div>

            <div onClick={logout} style={{ cursor: "pointer", fontSize: '13px', color: "#AAAAAA" }}>

              <img style={{ width: '20px' }} src={logoutLogo} alt='image not found ' />
            </div>

          </div>
        </div>
      ) : loginType === "TRANSLATOR" ? (
        <div className="sidebar">
          <div className="sidebar-logo">
            <img src={logo} alt="no logo" />
          </div>
          <div className="sidebar-nav">
            <p onClick={() => setActiveView("management")} className="nav-item">

              <img style={{ width: '20px' }} src={homeIcon} alt='image not found ' />

            </p>
            <p onClick={() => setActiveView("translator")} className="nav-item">
              <img style={{ width: '30px' }} src={FrameIcon} alt='image not found' />
            </p>
            <p onClick={() => setActiveView("Proofreading")} className="nav-item">

              <img style={{ width: '20px' }} src={profredingIocn} alt='image not found' />

            </p>
            <p onClick={() => setActiveView("history")} className="nav-item">
              <img style={{ width: '20px' }} src={historyIcon} alt='image not found' />

            </p>

          </div>

          <div>

            <div style={{ cursor: "pointer", marginBottom: '10px', color: '#AAAAAA' }}>

              <img
                style={{ width: '20px', borderRadius: "50%" }}
                onClick={() => setActiveView("userProfile")}
                src={userData?.imageUrl || userIcon}
                alt='image not found'
              />
            </div>

            <div onClick={logout} className="sidebar-bottom" style={{ color: '#AAAA', cursor: "pointer" }}>
              <img style={{ width: '20px' }} src={logoutLogo} alt='image not found ' />
            </div>

          </div>
        </div>
      ) : (
        <div className="sidebar">
          <div className="sidebar-logo">
            <img src={logo} alt="no logo" />
          </div>
          <div className="sidebar-nav">
            <p onClick={() => setActiveClientView("client")} className="nav-item">
              <img style={{ width: '20px' }} src={homeIcon} alt='image not found ' />
            </p>
            <p onClick={() => setActiveClientView("clientCompleted")} className="nav-item">
              <img style={{ width: '30px' }} src={FrameIcon} alt='image not found' />

            </p>
          </div>

          <div>
            <div style={{ cursor: "pointer", marginBottom: '10px', color: '#AAAAAA' }}>

              <img
                style={{ width: '20px', borderRadius: "50%" }}
                onClick={() => setActiveClientView("userProfile")}
                src={userData?.imageUrl || userIcon}
                alt='image not found'
              />
            </div>

            <div onClick={logout} className="sidebar-bottom" style={{ cursor: "pointer" }}>
              <img style={{ width: '20px' }} src={logoutLogo} alt='image not found ' />

            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;

